module.exports = __webpack_public_path__ + "static/5-7fc81949a7ebad10e53435779a5d3acd.jpg";